'use client'

import { FeatureFlagsContext } from './FeatureFlagsProvider'
import React, { ReactNode, useContext } from 'react'

interface FeatureFlagProps {
    flag: string
    fallback?: ReactNode
    children: ReactNode
}

export const FeatureFlag = ({ flag, fallback = null, children }: FeatureFlagProps) => {
    const featureFlags = useContext(FeatureFlagsContext)
    const isEnabled = featureFlags?.[flag] ?? false
    return isEnabled ? <>{children}</> : <> {fallback}</>
}
